<template>
  <b-modal
    :id="'add-event-modal'"
    :cancel-title="$t('Cancel')"
    centered
    no-close-on-backdrop
    :ok-title="subPlage && subPlage.id ? $t('Modify') : $t('Add')"
    size="xs"
    @close="emitCloseModal"
    @hide="resetModal"
    @ok="addEvent"
    @submit.stop.prevent="addEvent">
    <template #modal-header="{ close }">
      <div class="modalHeader">
        <h5 class="modal-title mb-0">{{ (subPlage && subPlage.id ? $t('Modify') : $t('Add')) + " " + $t('event') }}</h5>
        <b-button variant="close" @click="close">&times;</b-button>
      </div>
    </template>

    <div>
      <b-form ref="formEvent" @submit.stop.prevent="addEvent">
        <b-form-group class="medium-label mb-4" label="Nom" label-for="name-input">
          <b-form-input id="name-input" v-model="form.name.value" required type="text"></b-form-input>
        </b-form-group>

        <b-row>
          <b-col md="6">
            <b-form-group class="medium-label mb-4" label="Du" label-for="start-date-input">
              <datepicker-input
                :id="'start-date-input'"
                v-model="form.startDate.value"
                :state="form.startDate.state"
                required
                @change="removeInvalidFeedback('startDate')"
                @input="removeInvalidFeedback('startDate')">
              </datepicker-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group class="medium-label mb-4" label="Au" label-for="end-date-input">
              <datepicker-input
                :id="'end-date-input'"
                v-model="form.endDate.value"
                :state="form.endDate.state"
                required
                @change="removeInvalidFeedback('endDate')"
                @input="removeInvalidFeedback('endDate')">
              </datepicker-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api'
import i18n from "../../i18n";
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";

export default {
  name: 'AddEventModal',
  components: {
    DatepickerInput
  },
  props: {
    customKey: {
      type: Number,
      required: true
    },
    operation: {
      type: Object,
      default: null
    },
    evenement: {
      type: null,
      required: false,
      default: null
    },
    subPlage: {
      type: Object,
      required: false,
      default: null
    }
  },

  emits: ['didAddEvenement', 'didUpdateEvenement', 'didCloseModal'],
  watch: {
    customKey() {
      if (this.evenement && this.evenement.id && !this.subPlage) {
        this.objectId = this.evenement.objectLinked.id
        this.objectType = this.evenement.objectLinked.type
        this.form.startDate.value = this.convertDate(this.evenement.startEvent)
        if (this.evenement.endEvent) {
          this.form.endDate.value = this.convertDate(this.evenement.endEvent)
        } else {
          this.form.endDate.value = undefined
        }
      } else if(this.subPlage && this.subPlage.id){
        this.objectId = null
        this.objectType = null
        this.form.name.value = this.subPlage.name
        this.form.startDate.value = this.convertDate(this.subPlage.startEvent)
        if (this.subPlage.endEvent) {
          this.form.endDate.value = this.convertDate(this.subPlage.endEvent)
        } else {
          this.form.endDate.value = undefined
        }
      } else{
        this.resetModal()
      }
    },
  },
  data() {
    return {
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        startDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        endDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
      },
      errorOccurred: false,
      objectId: null,
      objectType: null,
    }
  },


  methods: {

    emitCloseModal() {
      this.errorOccurred = false
      this.$emit("didCloseModal")
    },

    resetModal() {
      if (!this.errorOccurred) {
        this.form.name.value = null
        this.form.startDate.value = null
        this.form.endDate.value = null
        this.objectType = null
        this.objectId = null
      }
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    convertDate(currentDate) {
      const date = new Date(currentDate);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    async addEvent($event) {
      const form = this.$refs.formEvent;
      $event.preventDefault();
      if (!form.reportValidity()) {
        this.errorOccurred = true;
        return
      }

      const data = new FormData();
      data.append('name', this.form.name.value);
      data.append('startEvent', this.form.startDate.value);
      data.append('endEvent', this.form.endDate.value);

      if (this.objectId && this.objectType) {
        data.append('objectId', this.objectId);
        data.append('event_type', this.objectType);
      }


      let url = 'sousPlageEvenement'
      if (this.subPlage && this.subPlage.id) {
        url = '/sousPlageEvenement/' + this.subPlage.id
      }

      try {
        const response = await api({
          method: 'POST',
          url: url,
          data: data
        });

        this.successToast(response.data.name);
        this.errorOccurred = false;

        if (this.subPlage && this.subPlage.id) {
          this.$emit('didUpdateEvenement', response.data);
        } else {
          this.$emit('didAddEvenement', response.data);
        }

        this.resetModal();
        this.hideModal();
      } catch (error) {
        console.error(error);
        this.errorOccurred = true;
        if (error.response && error.response.status === 403) {
          const invalidField = error.response.data.invalidField;
          this.form[invalidField].state = false;
          this.form[invalidField].invalidFeedback = i18n.t(error.response.data.message);
        }
      }
    },

    hideModal() {
      this.$bvModal.hide('add-event-modal')
    },

    successToast(name) {
      this.$bvToast.toast(this.$i18n.t('Event') + ' "' + name + '" ' + this.$i18n.t('registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }
}
</script>

<style scoped>
.modalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/operationPlanning/AddEventModal.vue